module.exports = __webpack_public_path__ + "img/HTCC-AC01_dimension.5e0ec92e.jpg";